import Routes from "./pages/Routes";

const App: React.FC = () => {
  return <Routes />;
};

export default App;
